export const certifications = [
  "AWS Certified Cloud Practitioner",
  "Backend Specialization",
];
